import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
};

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { clearError } = transactionsSlice.actions;

export const selectLoading = (state) => state.transactions.loading;
export const selectError = (state) => state.transactions.error;

export default transactionsSlice.reducer;
